import { useMemo } from 'react'
import { SummaryItem } from '../types'
import { isDayToday, isDayYesterday, normalizeSummaryDate } from '../utils'

export function useSummaryDate(summary?: SummaryItem) {
  const today = useMemo(() => {
    return new Date()
  }, [])

  const date = useMemo(() => {
    if (!summary) {
      return null
    }
    return normalizeSummaryDate(summary.summaryDate)
  }, [summary])

  const isToday = useMemo(() => {
    if (!date) {
      return false
    }
    return isDayToday(date)
  }, [today, date])

  const isYesterday = useMemo(() => {
    if (!date) {
      return false
    }
    return isDayYesterday(date)
  }, [date])

  const dayLabel = useMemo(() => {
    if (!date) {
      return 'Daily Summary'
    }
    const prettyDate = date.toLocaleString('en-US', { month: 'long', day: 'numeric', weekday: 'long' })
    return isToday ? 'Today' : isYesterday ? 'Yesterday' : prettyDate
  }, [isToday, isYesterday, date])

  return {
    date,
    isToday,
    isYesterday,
    dayLabel,
  }
}
